import uniqBy from "lodash/uniqBy";

export default {
  setCourses(state, courses) {
    state.courses = courses;
  },
  setBannerCourses(state, courses) {
    state.banner_courses = courses;
  },
  setCourse(state, course) {
    state.course = course;
  },
  setPreviewCourse(state, course) {
    state.previewCourse = course;
  },
  setProgress(state, progress) {
    state.progress = progress;
  },
  setCourseProgress(state, course_progress) {
    state.course_progress = course_progress;
  },
  setCategories(state, categories) {
    state.categories = categories;
  },
  setCurrentExam(state, currentExam) {
    state.current_exam = currentExam;
  },
  setLastLessons(state, lastLessons) {
    state.last_lessons = lastLessons;
  },
  setLessons(state, lessons) {
    state.lessons = lessons;
  },
  setMustSeeCourses(state, courses) {
    state.must_see_courses = courses;
  },
  setRecentlyLaunched(state, courses) {
    state.recently_launched = courses;
  },
  setCurrentMaster(state, master) {
    state.current_master = master;
  },
  setCurrentBook(state, book) {
    state.current_book = book;
  },
  pushHighlightedCategories(state, categorie) {
    state.highlighted_categories.push(categorie);
  },

  pushConferencesHighlighted(state, conference) {
    state.conferences_highlighted.push(conference);
  },
  setConferences(state, conferences) {
    state.conferences = conferences;
  },
  setTeachers(state, teachers) {
    state.teachers = teachers;
  },
  setRankedCourses(state, rankedCourses) {
    state.ranked_courses = rankedCourses;
  },
  setCategoryCoursesShowing(state, rankedCourses) {
    state.category_courses_showing = rankedCourses;
  },
  setMyList(state, courses) {
    state.my_list = courses;
  },
  setMasters(state, masters) {
    state.masters = masters;
  },
  setMaster(state, master) {
    state.master = master;
  },
  setMasterCourses(state, courses) {
    state.masterCourses = courses;
  },
  setConferenceCategories(state, categories) {
    state.conference_categories = categories;
  },
  setCoursesCollection(state, collection) {
    state.coursesCollection.push(collection);
  },
  setWatchedCourses(state, watched_courses) {
    state.watched_courses = watched_courses;
  },
  setStartedCourses(state, started_courses) {
    state.started_courses = started_courses;
  },
  setCompletedCourses(state, completed_courses) {
    state.completed_courses = completed_courses;
  },
};
